import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import GenericTable from "components/CRPComponents/Tables/GenericTable";
import DefaultCell from "components/CRPComponents/Tables/components/DefaultCell";
import LinkCell from "components/CRPComponents/Tables/components/LinkCell";
import { ListProps } from "./types";
import { GET_ALL_QUERY, GetAllGql } from "./queries/getAll";

function List(props: ListProps) {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <GenericTable<GetAllGql>
        initialVariables={{
          page: 1,
          perPage: 10,
          search: null,
        }}
        path={`${props.path}/chaves-globais`}
        query={GET_ALL_QUERY}
        formatRows={(data) => data.GlobalKeys.items}
        formatPagination={(data) => data.GlobalKeys.paginationInfo}
        title="NOVA CHAVE GLOBAL"
        useDefaultFilter={false}
        columnsTable={[
          {
            Header: "Chave",
            accessor: "key",
            Cell: ({ value }: any) => (
              <LinkCell href={`${props.path}/chaves-globais/${value}`} value={value} />
            ),
          },
          {
            Header: "Valor",
            accessor: "value",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
        ]}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default List;
